/**
 * Common Control Group Constants
 *
 * Shared constants and configurations used across control groups
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import { __ } from '@wordpress/i18n';

import type { UnitOption } from './types';

/**
 * Responsive breakpoint labels
 */
export const BREAKPOINT_LABELS = {
	desktop: __( 'Desktop', 'redfox-thank-you' ),
	tablet: __( 'Tablet', 'redfox-thank-you' ),
	mobile: __( 'Mobile', 'redfox-thank-you' ),
} as const;

/**
 * Common responsive breakpoints for media queries
 */
export const RESPONSIVE_BREAKPOINTS = {
	desktop: '', // No max-width for desktop
	tablet: '1023px',
	mobile: '767px',
} as const;

/**
 * Common unit options for size-related controls
 */
export const COMMON_UNITS: UnitOption[] = [
	{ label: 'px', value: 'px' },
	{ label: 'em', value: 'em' },
	{ label: 'rem', value: 'rem' },
	{ label: '%', value: '%' },
	{ label: 'vh', value: 'vh' },
	{ label: 'vw', value: 'vw' },
];

/**
 * Extended unit options including additional units
 */
export const EXTENDED_UNITS: UnitOption[] = [
	...COMMON_UNITS,
	{ label: 'ch', value: 'ch' },
	{ label: 'ex', value: 'ex' },
	{ label: 'cm', value: 'cm' },
	{ label: 'mm', value: 'mm' },
	{ label: 'in', value: 'in' },
	{ label: 'pt', value: 'pt' },
	{ label: 'pc', value: 'pc' },
];

/**
 * Default range control settings
 */
export const DEFAULT_RANGE_SETTINGS = {
	min: 0,
	max: 200,
	step: 1,
} as const;

/**
 * Common reset button labels
 */
export const RESET_LABELS = {
	reset: __( 'Reset', 'redfox-thank-you' ),
	resetAll: __( 'Reset All', 'redfox-thank-you' ),
	clear: __( 'Clear', 'redfox-thank-you' ),
	default: __( 'Default', 'redfox-thank-you' ),
} as const;

/**
 * Common CSS units that are valid
 */
export const VALID_CSS_UNITS = [
	'px',
	'em',
	'rem',
	'%',
	'vh',
	'vw',
	'ch',
	'ex',
	'cm',
	'mm',
	'in',
	'pt',
	'pc',
	'vmin',
	'vmax',
] as const;

/**
 * Common preset sizes
 */
export const COMMON_PRESET_SIZES = [
	0, 4, 8, 12, 16, 20, 24, 32, 40, 48, 64,
] as const;
